var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seeker"},[_c('audio',{ref:"audio",attrs:{"src":_vm.speechUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }